import { render } from "./BlogPreviewSkeleton.vue?vue&type=template&id=48ef45ba&scoped=true"
import script from "./BlogPreviewSkeleton.vue?vue&type=script&lang=js"
export * from "./BlogPreviewSkeleton.vue?vue&type=script&lang=js"

import "./BlogPreviewSkeleton.vue?vue&type=style&index=0&id=48ef45ba&scoped=true&lang=css"

import exportComponent from "C:\\code repo\\iebrewers.org\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ef45ba"]])

export default __exports__